import React from 'react';

/**
 * Ignores harmless errors that are thrown by the browser.
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
 * https://stackoverflow.com/a/72393165/9202501
 */
export function useIgnoreBenignErrors() {
  const defaultOnErrorFn = React.useRef<OnErrorEventHandlerNonNull | null>(null);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;

    defaultOnErrorFn.current = window.onerror;

    window.onerror = (...args) => {
      if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring:', args[0]);
        return true;
      }

      // Call the original error handler
      defaultOnErrorFn.current && defaultOnErrorFn.current(...args);

      return;
    };

    const originalError = defaultOnErrorFn.current;

    return () => {
      window.onerror = originalError;
    };
  }, []);
}
